import { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import ModalCloseButton from "../../components/ModalCloseButton/ModalCloseButton"
import "../../assets/css/icon.css";
import "./Track-order.css";
import { FaChevronUp, FaChevronDown, FaBox, FaTruck, FaStore, FaCheckCircle, FaMapMarkerAlt, FaClock, FaCreditCard, FaPhoneAlt, FaTicketAlt } from 'react-icons/fa';


const SingleOrder = (props) => {
  const orderData = props?.order;
  const [showOrder, hideOrder] = useState(false);
  const deliveryStates = ["ASSIGNING_DRIVER", "ON_GOING", "PICKED_UP", "COMPLETED"]
  const [activeStateDelivery, changeStateDelivery] = useState(["", "", "", ""])
  const [showSummary, setShowSummary] = useState(false);

  const returnAddons = (obj) => {

    let addonString = ""
    if (obj.adons.length > 0) {
      for (let i = 0; i < obj.adons.length; ++i) {

        if (i === obj.adons.length - 1) {
          addonString += obj.adons[i].name
        } else {
          addonString += obj.adons[i].name + ", "
        }
      }
    }

    return addonString
  }

  useEffect(() => {
    if (props.order) {
      const status = props.order.lalamove_status
      let numOfActive = deliveryStates.indexOf(status)
      let x = [...activeStateDelivery]
      for (let i = 0; i <= numOfActive; ++i) {
        x[i] = "active" //make a shallow copy of the array
        console.log(activeStateDelivery)
        changeStateDelivery([...x])
      }
    }
  }, [props.order])

  return (
    <>
      <Modal size="sm" centered show={showOrder}>
        <Modal.Header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0.75rem 1rem",
          }}
        >
          <h5
            className="view-order"
            style={{
              marginLeft: "10px",
              marginTop: "10px",
            }}
          >
            View Order
          </h5>

          <ModalCloseButton
            onClick={() => hideOrder(false)}
            style={{ position: 'static', width: '34px', height: '34px' }}
          />
        </Modal.Header>


        <Modal.Body className="p-3">
          <div className="order-summary">
            <div
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '16px',
                width: '100%',  // lowercase "width"
                margin: '20px auto',
                backgroundColor: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
            >
              <table
                className="invoice-order-table"
                style={{
                  color: 'black',
                  width: '100%',
                  borderCollapse: 'collapse',
                  tableLayout: 'fixed',
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #ccc', color: 'black' }}>
                    <th
                      style={{
                        textAlign: 'left',
                        padding: '8px',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        color: 'black',
                        fontWeight: 'bold',
                      }}
                    >
                      Invoice Number
                    </th>
                    <th
                      style={{
                        textAlign: 'right',
                        padding: '8px',
                        borderBottom: '1px solid #ccc',
                        color: 'black',
                        fontWeight: 'bold',
                      }}
                    >
                      Order Token Number
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr style={{ borderBottom: '1px solid #ccc' }}>
                    <td
                      style={{
                        textAlign: 'left',
                        padding: '8px',
                        borderRight: '1px solid #ccc',
                        fontSize: '14px',
                      }}
                    >
                      {orderData?.invoice_no}
                    </td>
                    <td
                      style={{
                        textAlign: 'right',
                        padding: '8px',
                        fontSize: '14px',
                      }}
                    >
                      {orderData?.order_token_no}
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      textAlign: 'left',
                      padding: '8px',
                      fontWeight: 'bold',

                    }}>
                      Order Number:
                    </td>
                    <td style={{
                      textAlign: 'right',
                      padding: '8px',
                      fontSize: '14px',
                    }}>
                      {orderData?.order_no}
                    </td>
                  </tr>
                  {/* Arrival Time Row */}
                  {orderData?.type_for_api !== "Pickup" && (
                    <tr style={{ borderTop: '1px solid #ccc' }}>
                      <td style={{
                        textAlign: 'left',
                        padding: '8px',
                        fontWeight: 'bold',
                      }}>
                        Arrival time:
                      </td>
                      <td style={{
                        textAlign: 'right',
                        padding: '8px',
                        fontSize: '14px',
                      }}>
                        {orderData?.estimated_arrival_time}
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
            <div className="order-summary-dropdown">
              <button
                className="dropdown-toggle"
                onClick={() => setShowSummary(!showSummary)}
                style={{
                  width: '100%', // 🔹 Makes button full width
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  justifyContent: 'space-between', // 🔹 Push icon to far right
                  padding: '8px', // Optional padding
                  backgroundColor: '#fcfcfcff', // Optional background
                  border: 'none',
                  // Optional border
                  borderRadius: '6px',         // Optional rounding
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 8px",
                  border: "1px solid rgb(204, 204, 204)",
                  cursor: "pointer"
                }}
              >
                Order Summary {showSummary ? <FaChevronUp /> : <FaChevronDown />}
              </button>

              {showSummary && (
                <div
                  style={{
                    position: 'absolute',     // position relative to parent div
                    top: '100%',            // exactly below the button
                    left: 0,                // align left edges
                    width: '100%',
                    Height: '300px',     // limit height so it doesn't get too tall
                    overflowY: 'auto',           // same height as parent container
                    backgroundColor: 'white',
                    padding: '18px 30px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    marginTop: '4px',
                    borderRadius: '17px',       // small gap below button
                  }}
                >

                  {/* Your existing dropdown and above table here */}

                  {/* Table with Item, Qty and Price below */}
                  <table className="items-table" style={{ width: '100%', color: 'black', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', padding: '8px' }}>Item</th>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #ccc', padding: '8px' }}>Qty</th>
                        <th style={{ textAlign: 'right', borderBottom: '1px solid #ccc', padding: '8px' }}>Price</th>

                      </tr>
                    </thead>
                    <tbody>
                      {
                        props.order && props.order.item.map((item, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '8px', fontSize: '14px', }}>{item.name}
                              {item?.adons?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: "4px",
                                    fontSize: "12px",
                                    color: "#666",
                                    boxShadow: "none"
                                  }}
                                >
                                  ({item.adons.map(e => `${e?.quantity || 1} ${e?.name || ""}`).filter(Boolean).join(", ")})
                                </div>
                              )}
                              {item?.combo_products?.length > 0 && (
                                <div
                                  style={{
                                    marginTop: "4px",
                                    fontSize: "12px",
                                    color: "#666",
                                    boxShadow: "none"
                                  }}
                                >
                                  ({item.combo_products.map(e => e?.name).filter(Boolean).join(", ")})
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: 'center', padding: '8px', fontSize: '14px', }}>{item.quantity}</td>
                            <td style={{ textAlign: 'right', padding: '8px', fontSize: '14px', }}>{item.total_for_single_item.toFixed(2)}</td>

                          </tr>
                        ))}
                      <>
                        {
                          orderData?.type_for_api === "Delivery" &&
                          <tr>
                            <td style={{ borderBottom: '1px solid #ccc' }}></td>
                            <td style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              Delivery Charge:
                            </td>
                            <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              {parseFloat(orderData?.delivery_charge).toFixed(2)}
                            </td>
                          </tr>
                        }
                        {orderData?.small_order_fee > 0 && (
                          <tr>
                            <td style={{ borderBottom: '1px solid #ccc' }}></td>
                            <td style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              Small Order Charge:
                            </td>
                            <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                              {parseFloat(orderData?.small_order_fee).toFixed(2) ?? "0.00"}
                            </td>
                          </tr>)}
                      </>
                      <tr>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          Discount Amount:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          {orderData?.discount_amount}
                        </td>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                      </tr>
                      <tr>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          GST:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '1px solid #ccc', fontSize: '14px', }}>
                          {orderData?.tax_amount.toFixed(2)}
                        </td>
                        <td style={{ borderBottom: '1px solid #ccc' }}></td>
                      </tr>
                      <tr>
                        <td style={{ borderBottom: '2px solid #333' }}></td>
                        <td style={{ textAlign: 'center', padding: '5px', borderBottom: '2px solid #333', fontSize: '14px', }}>
                          Round off:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', borderBottom: '2px solid #333', fontSize: '14px', }}>
                          {orderData?.round_off_amount && Number(orderData.round_off_amount.toFixed(2)) !== 0
                            ? `-${orderData.round_off_amount.toFixed(2)}`
                            : "0.00"}
                        </td>
                        <td style={{ borderBottom: '2px solid #333' }}></td>
                      </tr>

                      <tr style={{ borderBottom: '2px solid #333' }}>
                        <td style={{ padding: '8px' }}></td>
                        <td style={{ textAlign: 'center', padding: '8px', fontSize: '14px', }}>
                          Total + GST:
                        </td>
                        <td style={{ textAlign: 'right', padding: '8px', fontSize: '14px', }}>
                          {parseFloat(orderData?.received_amount).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3" style={{ textAlign: 'right', paddingTop: '20px', }}>
                          <button className="order-close-btn"
                            onClick={() => hideOrder(false)}
                            style={{
                              backgroundColor: '#e01e26',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '5px 20px',
                              cursor: 'pointer'
                            }}
                          >
                            Close
                          </button>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="view-order-btn" onClick={() => { hideOrder(false) }} >Close</div>
        </Modal.Footer>
      </Modal>

      <div className="mb-1">
        <div className="track-gutter my-2 mx-2 mx-md-5" data-testid={props.order.ref_no}>
          <div className="ins">
            {
              props?.order?.type_for_api === "Delivery" ? (
                <div className="order-header-card">
                  <div className="token-desc">
                    <FaTicketAlt className="token-icon-header" /> Order Token Number <span className="token-number-value">{props?.order?.order_token_no}</span>
                  </div>
                  {["CANCELED", "EXPIRED"].includes(props?.order?.lalamove_status) && (
                    <div className="status-badge-expired">
                      YOUR ORDER HAS BEEN {props.order.lalamove_status}
                    </div>
                  )}
                  <button onClick={() => { hideOrder(true) }} className="view-order-btn-red">
                    View order
                  </button>
                </div>) :

                (<div className="order-header-card">
                  <div className="token-desc">
                    <FaTicketAlt className="token-icon-header" /> Order Token Number <span className="token-number-value">{props?.order?.order_token_no}</span>
                  </div>
                  <button onClick={() => { hideOrder(true) }} className="view-order-btn-red">
                    View order
                  </button>
                </div>)
            }
            {props?.order?.type_for_api === "Delivery" ? (
              <>
                <div className="stepper-container">
                  <ul key={1} className="stepper-list">
                    <li className={activeStateDelivery[0] ? "active" : ""}>
                      <div className="stepper-icon"><FaBox /></div>
                      <span>Assigning Driver</span>
                    </li>
                    <li className={activeStateDelivery[1] ? "active" : ""}>
                      <div className="stepper-icon"><FaTruck /></div>
                      <span>On Going</span>
                    </li>
                    <li className={activeStateDelivery[2] ? "active" : ""}>
                      <div className="stepper-icon"><FaStore /></div>
                      <span>Picked Up</span>
                    </li>
                    <li className={activeStateDelivery[3] ? "active" : ""}>
                      <div className="stepper-icon"><FaCheckCircle /></div>
                      <span>Completed</span>
                    </li>
                  </ul>
                </div>

                <div key={2} className="info-grid">
                  <div className="info-card">
                    <div className="info-header">
                      <FaMapMarkerAlt className="icon-red" /> <span>DELIVER TO</span>
                    </div>
                    <div className="info-body">
                      {props?.order?.d_address || "-"}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaClock className="icon-red" /> <span>ESTIMATED ARRIVAL</span>
                    </div>
                    <div className="info-body">
                      {props?.order?.estimated_arrival_time}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaCreditCard className="icon-red" /> <span>PAYMENT</span>
                    </div>
                    <div className="info-body">
                      CARD **** **** {props?.order?.last_4_card_digits}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaPhoneAlt className="icon-red" /> <span>CONTACT US</span>
                    </div>
                    <div className="info-body-contact">
                      {props?.order?.business_location_mobile_for_delivery}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="stepper-container">
                  <ul key={1} className="stepper-list pickup">
                    <li className="active">
                      <div className="stepper-icon"><FaBox /></div>
                      <span>Order Received</span>
                    </li>
                    <li className={props.order.pickup_completed !== 0 ? "active" : ""}>
                      <div className="stepper-icon"><FaStore /></div>
                      <span>Collected</span>
                    </li>
                  </ul>
                </div>

                <div key={2} className="info-grid">
                  <div className="info-card">
                    <div className="info-header">
                      <FaStore className="icon-red" /> <span>PICK UP OUTLET</span>
                    </div>
                    <div className="info-body">
                      {props.order.business_location_name_for_pickup || "NA"}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaClock className="icon-red" /> <span>PICKED UP TIME</span>
                    </div>
                    <div className="info-body">
                      {props.order.d_date} {props.order.d_time}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaCreditCard className="icon-red" /> <span>PAYMENT</span>
                    </div>
                    <div className="info-body">
                      {props.order.paymentType?.toUpperCase()} {props.order.last_4_card_digits}
                    </div>
                  </div>

                  <div className="info-card">
                    <div className="info-header">
                      <FaPhoneAlt className="icon-red" /> <span>CONTACT US</span>
                    </div>
                    <div className="info-body-contact">
                      {props.order.business_location_mobile_for_pickup || "NA"}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleOrder;